module.exports = __webpack_public_path__ + "static/media/TopDelivery_5.8982ff48.png";